import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCrQ3W9dTQYYf97GTetOwGTJce_ySfnQtM",
  authDomain: "souza-villa.firebaseapp.com",
  projectId: "souza-villa",
  storageBucket: "souza-villa.firebasestorage.app",
  messagingSenderId: "961446489342",
  appId: "1:961446489342:web:fc6cc3ec5ff3157208c9af"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const functions = getFunctions(app);
export default app;
